import { render, staticRenderFns } from "./WorkDescription.vue?vue&type=template&id=208efa3e&"
import script from "./WorkDescription.ts?vue&type=script&lang=js&"
export * from "./WorkDescription.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports